var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.39686 15.0964C2.43515 14.7518 2.45429 14.5795 2.50642 14.4185C2.55268 14.2756 2.61802 14.1396 2.70069 14.0143C2.79388 13.873 2.91645 13.7504 3.1616 13.5052L14.1669 2.5C15.0873 1.57952 16.5797 1.57952 17.5002 2.5C18.4207 3.42047 18.4207 4.91286 17.5002 5.83333L6.49493 16.8386C6.24978 17.0837 6.12721 17.2063 5.9859 17.2995C5.86054 17.3821 5.72457 17.4475 5.5817 17.4937C5.42067 17.5459 5.24838 17.565 4.9038 17.6033L2.0835 17.9167L2.39686 15.0964Z",
    stroke: "#475467",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.8de1900e67cce9eabf6923684c9992df.svg";
export { ForwardRef as ReactComponent };